import './styles.scss';

const AppContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="appContainer">{children}</div>;
};

export { AppContainer };
